export enum State {
  loading = 'loading',
  warning = 'warning',
  checked = 'checked',
  error = 'error'
}
